import React, { useState, useEffect } from 'react';
import { Layout, Menu, Drawer, Button, Grid, Affix } from 'antd';
import { MenuOutlined, HomeOutlined } from '@ant-design/icons';
import { Link, useLocation, useParams, useNavigate } from 'react-router-dom'; // Importar useLocation
import axios from "axios";

const { Header } = Layout;
const { useBreakpoint } = Grid;

export const NavbarPilotos = () => {
  const location = useLocation(); // Obtener ubicación actual
  const screens = useBreakpoint();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [asociaciones, setAsociaciones] = useState([]);
  const [asociacion, setAsociacion] = useState([])
  const [asociacionActiva, setAsociacionActiva] = useState(null);
  const [asociacionFiltrada, setAsociacionFiltrada] = useState([]);
  const {id_asociacion} = useParams();
  const navigate = useNavigate();
  // console.log("locación", location.pathname === "/reset-password")
  const showDrawer = () => setDrawerVisible(true);
  const onClose = () => setDrawerVisible(false);

  useEffect(() => {
    fetchAsociaciones();
  }, [id_asociacion]);

  const fetchAsociaciones = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_DOMINIO}/asociaciones-publicas/`);
        if (response.status === 200) {
          const asociacionesData = response.data;
          setAsociaciones(asociacionesData);

          if (asociacionesData) {
            const asociacionesEncontradas = asociacionesData.find((asoc) => asoc.id == id_asociacion);
            if (asociacionesEncontradas) {
              setAsociacionActiva(asociacionesEncontradas)
            }
          }
          
        
      }
    } catch (error) {
      console.error("Error al obtener asociaciones:", error);
    }
  };


  return (
    <Affix offsetTop={0}>
       <Header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 2%', height: '64px' }}>
        {/* Logo */}
        <div className="logo" style={{
          flex: '0 0 200px',
          display: 'flex',
          alignItems: 'center',
        }}>
          <img
            src={asociacionActiva?.imagen
              ? `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${asociacionActiva.id}/IMAGENES/ASOCIACIONES/${asociacionActiva.imagen}`
              :"/img/logo-mundo-piloto.svg"}
            alt="Logo Asociación"
            style={{ maxWidth: "50%", height: "64px", objectFit: "contain" }}
          />
        </div>
        {location.pathname !== "/reset-password" ? (
          <div translate="no" className="notranslate">
            <Button className="buttonLink" style={{ display: "flex", alignItems: "center", padding: '0 10px', color: "#fff", fontFamily:'Roboto Condensed' }}
              onClick={() => navigate(`/${asociacionActiva.siglas}`)}>Home</Button>
          </div>
        ) : ""}
        {/* {screens.md ? (
          <Menu style={{ backgroundColor: "transparent" }}>
            <div>
              <Button className="buttonLink" style={{ display: "flex", alignItems: "center", padding: '0 10px', color: "#fff", fontFamily:'Roboto Condensed' }}
                onClick={() => navigate(`/${asociacionActiva.siglas}`)}>Home</Button>
            </div>
          </Menu>
        ) : (
          <HomeOutlined style={{ width: "30px", height: "30px", color: "#fff" }}onClick={() => navigate(`/${asociacionActiva.siglas}`)}/>
        )} */}

        {/* Menú móvil */}

        <Drawer
          placement="right"
          closable={false}
          onClose={onClose}
          visible={drawerVisible}
          width={200}
        >
          <Menu mode="inline" style={{ borderRight: 0 }}>
            {/* Agregar ítem de menú en el drawer también 
            {location.pathname === '/login' && (
              <Menu.Item key="home" >
                <Link to="/">Inicio</Link>
              </Menu.Item>
            )}
             Aquí irían los demás ítems del menú */}
          </Menu>
        </Drawer>
      </Header>
      <div style={{ width: "100%", height:"5vh" , backgroundColor:"var(--rojo)" }}></div>
    </Affix>
  );
};